<template>
  <div class="home">
    <section class="loooo" v-if="loading">
      <div class="loading">
        <p class="loading-text">Loading</p>
        <span class="dots"></span>
        <span class="dots"></span>
        <span class="dots"></span>
      </div>
    </section>
    <transition name="fade" appear>
    <section v-if="!loading">
      <div class="bg-box" :class="{upUP:turnUPlo}">
        <div class="bg" :style="{backgroundImage : 'url(' + currentImg + ')'}">
          <div class="bg-mask" @click="TurnUpp();adTurn()"></div>
        </div>
        <div class="logo-box" :class="{logoIn:turnUPlo}">
            <span class="logo-title">White Space</span>
        </div>
        <div class="nav-bar" :class="{fadeOut:turnUPlo}">
          <router-link @mouseover.native="changeImg(index)" :to="{ path: '/about', query: { roomId: room.id }}" tag='div' class="bar" :key="index" v-for="(room,index) in roomsInfo">
            <span class="foo"></span>
            <span class="room-title">{{room.name}}</span>
          </router-link>
        </div>
        <div class="title-box" :class="{fadeOut2:turnUPlo}">
          <span class="room-number">0{{currentIndex + 1}}</span>
          <span class="room-title">{{currentDetail}}</span>
        </div>
        <div class="contact-box" :class="{contactIn:turnUPlo}">
          <div class="icon-box">
            <img class="icon" :src='ig'>
            <img class="icon" :src='fb'>
          </div>
          <div class="content-box">
            <div class="mesg mesg1">
              <img class="icon" :src='phone'>
              <span class="content">02-17264937</span>
            </div>
            <div class="mesg">
              <img class="icon" :src='mesg'>
              <span class="content">whitespace@whitespace.com.tw</span>
            </div>
            <div class="mesg">
              <img class="icon" :src='homei'>
              <span class="content">台北市某條路十段30號</span>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" :class="{wrapperUP:turnUPlo}">
        <div class="container">
          <router-link tag='div' :to="{ path: '/about', query: { roomId: room.id }}" class="room-card" :key="index" v-for="(room,index) in roomsInfo">
            <div class="card-img" :style="{backgroundImage : 'url(' + infoCardImgs[index] + ')'}"></div>
            <div class="card-content">
              <span class="room-name">{{room.name}}</span>
              <span class="room-type">{{howBig[index]}}</span>
              <div class="mesg-box">
                <div class="price">NT.{{room.normalDayPrice}} <span class="small">平日</span></div>
                <div class="small price2">NT.{{room.holidayPrice}} <span class="small price2">假日</span></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <Footer v-if="turnUPlo"/>
    </section>
    </transition>
  </div>
</template>

<style lang="scss">
.home{
  position: relative;
  width: 100%;
  overflow: hidden;
}
section{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.loooo{
  // position: absolute;
  top:0;
  left: 0;
  width: 100%;
  background-color: rgb(255, 255, 255);
  height: 600px;
  z-index: 100;
}
.loading{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  width: 50%;
  height: 10%;
  font-size: 24px;
  font-weight: 500;
  &-text{
    display: inline-block;
  }
  .dots{
    display: inline-block;
    visibility: hidden;
    width: 4px;
    height: 4px;
    background-color: #000;
    border-radius: 50%;
    margin-left: 12px;
    &:nth-child(2){
      animation:loadinganimation1 2s infinite;
    }
    &:nth-child(3){
      animation:loadinganimation2 2s infinite;
    }
    &:nth-child(4){
      animation:loadinganimation3 2s infinite;
    }
  }
}
.bg-box{
  width: 100%;
  height: 100vh;
  position: relative;
  top: 0;
  left: 0;
  transition: all .5s;
  .bg{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: bottom;
    .bg-mask{
      position: absolute;
      top:0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to top,rgba(0,0,0,.15) rgba(0,0,0,0));
      cursor: pointer;
    }
  }
}
.logo-box{
  width: 165px;
  height: 165px;
  position: absolute;
  top: 5%;
  left: 5%;
  background-image: url(../assets/logo/logo-1.png);
  background-size: cover;
  transition: all .5s;
  user-select: none;
  .logo-title{
    position: absolute;
    right: 0px;
    bottom: 30px;
    width: 148px;
    font-size: 32px;
    color: #fff;
    text-align: center;
  }
}
.nav-bar{
  width: 25%;
  // height: 50%;
  background-color: #fff;
  position: absolute;
  right: 0;
  top: 5%;
  padding: 0 0 60px 0;
  transition: all .5s;
  &::before{
    content: '';
    position: absolute;
    bottom: -20px;
    right: 0;
    width: 14 / 15 * 100%;
    height: 20px;
    background-image: url(../assets/logo/dec-white-2.png);
    background-size: cover;
  }
  .foo{
    width: 24px;
    height: 1px;
    background-color: #000;
    opacity: 0;
    transition: all .2s;
  }
  .bar{
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: 36px;
    cursor: pointer;
    user-select: none;
    &:hover .foo{
      opacity: 1;
    }
  }
  .room-title{
    margin-left: 8px;
    font-weight: 300;
    letter-spacing: 2px;
  }
}
.title-box{
  position: absolute;
  left: 5%;
  bottom: 5%;
  width: 30%;
  transition: all .5s;
  .room-number{
    display: block;
    font-weight: 400;
    position: relative;
    font-size: 66px;
    color: #fff;
    &::before{
      content: '';
      position: absolute;
      bottom: 8px;
      width: 80px;
      height: 20px;
      background-image: url(../assets/logo/dec-white.png);
      background-size: cover;
    }
  }
  .room-title{
    font-weight: 400;
    display: block;
    font-size: 24px;
    color: #fff;
  }
}
.contact-box{
  position: absolute;
  bottom: 5%;
  right: 0;
  width: 14 / 15 *25%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  transition: all .5s;
  .icon-box{
    width: 100%;
    margin-bottom: 46px;
  }
  .icon{
    width: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  .content-box{
    width: 100%;
  }
  .mesg{
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 12px;
  }
  .mesg1{
    margin-top: 0;
  }
  .content{
    color: #fff;
    font-size: 16px;
    font-weight: 300;
  }
}
.logoIn{
  left: 49%;
  transform: translateX(-50%);
  top: 25%;
}
.fadeOut{
  right: -10%;
  opacity: 0;
  visibility: hidden;
}
.fadeOut2{
  left: -10%;
  opacity: 0;
}
.upUP{
  .bg-mask{
      background: linear-gradient(to top,rgba(0,0,0,.3) rgba(0,0,0,0)) !important ;
  }
}
.contactIn{
  flex-wrap: nowrap;
  width: 50%;
  bottom: 30%;
  right: 50%;
  transform: translateX(72%);
  .icon-box{
    width: 18%;
    margin-bottom: 0;
  }
  .content-box{
    width: 50%;
    position: relative;
    &::after{
      content: '';
      position: absolute;
      top: 0;
      left: -28px;
      width: 1px;
      height: 100%;
      background-color: #fff;
    }
  }
}
.wrapper{
  width: 100%;
  height: 0px;
  background-color: #fff;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  transition: all .5s;
  .container{
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-wrap: wrap;
    top: -110px;
    width: 948px;
    height: 100%;
    justify-content: space-between;
  }
}
.wrapperUP{
  height: 820px;
  opacity: 1;
  visibility: visible;
}
.room-name{
  display: block;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 1px;
  margin-top: 4px;
}
.room-type{
  display: block;
  position: relative;
  left: -30px;
  font-size: 12px;
  font-weight: 300;
  margin-top: 4px;
  letter-spacing: 1px;
  color: #6D7278;
  opacity: 0;
  transform: all .4s;
}
.mesg-box{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 18px;
  .price{
    font-size: 21px;
    font-weight: 300;
    letter-spacing: 1px;
  }
  .small{
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 1px;
  }
  .price2{
    color: #6D7278;
  }
}
.room-card{
  position: relative;
  width: 270px;
  height: 350px;
  box-shadow: 2px 2px 9px 0 rgba(0,0,0,.2);
  overflow: hidden;
  cursor: pointer;
  .card-img{
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position-y: bottom; //因圖片的內容都偏下方所以定位在底部
  }
  .card-content{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    background-color:rgba(256, 256, 256, .7) ;//#F7F7F7;
    padding: 20px 30px;
    text-align: left;
    transition: all .4s;
  }
  &:hover .card-content{
    height: 110px;
    background-color:rgba(256, 256, 256, .9) ;//#F7F7F7;
  }
  &:hover .room-type{
    opacity: 1;
    left: 0px;
  }
  &:hover .room-name{
    margin-top: 0px;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.2s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
@keyframes loadinganimation1 {
  0%{
    visibility: hidden;
  }
  20%{
    visibility: hidden;
  }
  100%{
    visibility: visible;
  }
}
@keyframes loadinganimation2 {
  0%{
    visibility: hidden;
  }
  50%{
    visibility: hidden;
  }
  100%{
    visibility: visible;
  }
}
@keyframes loadinganimation3 {
  0%{
    visibility: hidden;
  }
  80%{
    visibility: hidden;
  }
  100%{
    visibility: visible;
  }
}
</style>

<script>
import ig from '../assets/icon/instagram.svg'
import fb from '../assets/icon/facebook.svg'
import phone from '../assets/icon/phone.svg'
import mesg from '../assets/icon/envelope.svg'
import homei from '../assets/icon/home.svg'
import Footer from '@/components/Footer'

export default {
  name: 'home',
  data(){
    return {
      intervalID : null,
      currentIndex : 0,
      // currentImg : 'https://images.unsplash.com/photo-1551776235-dde6d482980b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80',
      ig : ig,
      fb : fb,
      phone: phone,
      mesg: mesg,
      homei: homei,
    }
  },
  components: {
    Footer,
  },
  computed: {
    roomsInfo() {
      if(this.$store.state.rooms.length < 1){
        return null
      }else{
        return this.$store.state.rooms
      }
    },
    currentDetail() {
      if(this.$store.state.rooms.length < 1){
        return ''
      }else{
        return this.roomsInfo[this.currentIndex].name
      }
    },
    turnUPlo() {
      return this.$store.state.turnUP
    },
    indexImgs() {
      return this.$imgUrl.indexRoomsImg()  //引入外部整理好的方法，return 各房間主圖片的路徑陣列
    },
    currentImg() {
      return this.indexImgs[this.currentIndex]
    },
    infoCardImgs() {
      return this.$imgUrl.detailRoomsImg()  //引入外部整理好的方法，return 各房間小卡圖片的路徑陣列
    },
    howBig() {
      let arr = []
      if(this.roomsInfo) return []
      else{
        this.roomsInfo.map(x=>{
          if(x.name.indexOf('Single')>-1){arr.push('單人房')}
          if(x.name.indexOf('Double')>-1){arr.push('雙人房')}
          if(x.name.indexOf('Twin')>-1){arr.push('多人房')}
        })
        return arr
      }
    },
    loading() {
      return this.$store.state.rooms.length > 0 ? false : true
    }
  },
  methods:{
    TurnUpp() {
      this.$store.commit('changeTurnUP')
    },
    changeImg(ind) {
      this.currentIndex = ind
      // this.currentImg = this.roomsInfo[ind].imageUrl
    },
    adTurn() {
      if(this.turnUPlo){
        this.intervalID = setInterval(()=>{
          if(this.currentIndex===5){this.currentIndex=0}
          else{this.currentIndex += 1}
          // this.currentImg = this.roomsInfo[this.currentIndex].imageUrl
        },3000)
      }else{
        clearInterval(this.intervalID)
      }
    },
  },
  beforeMount() {
    this.$store.dispatch('getRoomsInfo')
  },
}
</script>
